/* eslint-disable react/prop-types */
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useEffect, useState } from 'react';
// import TablePagination from "@mui/material/TablePagination";
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { visuallyHidden } from '@mui/utils';
import Dp from 'assets/dummy/buy.jpg';
import meter from 'assets/icons/meter.svg';
import { fontsize10, poppins400 } from 'theme/common.style';
import { checkbox_style } from './Table.style';
// import { Grid } from "antd";
import { Avatar, Pagination, Grid, useMediaQuery } from '@mui/material';
import { Stack } from '@mui/system';
import {
  displayFlex,
  imageCont,
  userDetCont,
} from 'component/ActivityContainer/ActivityContainer.style';
import OwnerCard from 'component/OwnerCard/OwnerCard';
import {
  ActionContainer,
  Contact,
  ProfileContainer,
  // TagContainer
} from './OwnerTabItem.util';
import { CategoryContainer, TagContainer } from './ContactTabItem.util';
import CancelIcon from '@mui/icons-material/Cancel';
import { makeStyles, styled, useTheme } from '@mui/styles';
import {
  getApiCall,
  getOwnerDetails,
  createTagDetails,
  editTagnames,
  getContactDetails,
  getTagDetails,
  getusertagDetails,
  storeTagnames,
} from 'api/apiService';
import { BuyersCard } from 'component/BuyersCard/BuyersCard';
import { Feedback } from 'component/BuyersCard/Feedback';
import { GET_BINDERID } from 'constant/app.config';
import Modal from 'react-modal';
import Popover from '@mui/material/Popover';
import { TagPopOver } from './Table';
import { useHistory } from 'react-router-dom';
import Moxochat from 'component/Moxochat/Moxochat';
import { datacontext } from 'modules/AppLayout/AppLayout';

const ExpandIcon = () => {
  return (
    <svg
      width="30"
      height="27"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="1"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M17.8291 7.19042L23.3192 7.19042L23.3192 12.6949"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23 7.5L17.75 12.75"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14.1748 21.8106L8.68467 21.8106L8.68467 16.3061"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.25 16.2559L9 21.5059"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox"></TableCell> */}
        {headCells?.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? "right" : "left"}
            align="left"
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ ...poppins400, ...fontsize10, color: '#666666' }}
          >
            <TableSortLabel
              sx={{ marginLeft: index == 0 ? '63px' : '0px' }}
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.string.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {/* Nutrition */}
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function EnhancedOwnerTable(props) {
  const { realTimeLog, setIschatopen } = React.useContext(datacontext);
  const isUserAction = React.useRef(false);
  const isInitialRender = React.useRef(true);
  // const { userproperties } = properties;
  const data = props.properties?.userDetails
    ? props.properties?.userDetails
    : props.properties?.data;

  const [feedBackData, setFeedBackData] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [address, setAddress] = useState();
  const {
    headCells,
    setProperties,
    setSelectedRows,
    selectedRows = [],
  } = props;
  const [selectedBuyers, setSelectedBuyers] = React.useState(selectedRows);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(null);
  const [selectedBuyerId, setSelectedBuyerId] = React.useState('');
  const [isHiddenRightArrow, setIsHiddenRightArrow] = React.useState(false);
  const [getpage, setgetPage] = React.useState(1);
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalpages] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [openOwner, setOpenOwner] = React.useState(false);
  const [row, setRow] = React.useState({});
  const [userType, setUserType] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openFeedback, setOpenFeedback] = React.useState(false);
  const [expandFeedback, setExpandFeedback] = React.useState(false);
  const [buyerId, setBuyerId] = React.useState('');
  const [showBackdrop, setShowBackDrop] = React.useState(false);
  const [position, setPosition] = React.useState(0);
  const [arrayCollection, setArrayCollection] = React.useState([]);
  const [indexValue, setIndexValue] = React.useState(null);
  const [isChecked, setIsChecked] = React.useState(false);
  const [changeToggle, setChangeToggle] = React.useState(false);
  const [isCardSelect, setIsCardSelect] = React.useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [postTagId, setPostTagId] = useState('');
  const [userName, setUserName] = useState('');
  const [userInitial, setUserInitial] = useState('');
  const [LoaderUser, setLoaderUser] = useState(false);
  const [LoaderTag, setLoaderTag] = useState(false);
  const [userTagDetails, setUserTagDetails] = useState([]);
  const [tagArray, setTagArray] = useState([]);
  const openPop = Boolean(anchorEl);
  const idPop = open ? 'simple-popover' : undefined;
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const Apifunctions = async () => {
    setLoaderUser(true);
    setLoaderTag(true);
    let selecteddata = [];
    let alldata = [];
    await getusertagDetails(postTagId).then((res) => {
      if (res?.tagDetails?.length != 0) {
        selecteddata = res?.tagDetails;
        setUserTagDetails(res?.tagDetails);
        setLoaderUser(false);
      } else {
        setUserTagDetails(res?.tagDetails);
        setLoaderUser(false);
      }
    });
    await getTagDetails(postTagId).then((res) => {
      if (res?.status == 1) {
        setLoaderTag(false);
      } else {
        setLoaderTag(false);
      }
      alldata = res?.tagDetails;
      const results = alldata.filter(
        ({ tagName: id1 }) =>
          !selecteddata.some(({ tagName: id2 }) => id2 === id1)
      );
      setTagArray(results);
    });
  };

  const handleIconClick = (id, event, name) => {
    setUserName(name);
    setPostTagId(id);
    if (anchorEl == null) {
      setAnchorEl(event.currentTarget);
    } else {
      setAnchorEl(null);
    }
  };

  const handleSelection = (buyerId, checked) => {
    let updatedRows;

    if (checked) {
      updatedRows = [...selectedBuyers, buyerId];
    } else {
      updatedRows = selectedBuyers.filter((id) => id !== buyerId);
    }

    isUserAction.current = true;
    setSelectedBuyers(updatedRows);
    setSelectedRows(updatedRows);

    setTimeout(() => {
      isUserAction.current = false;
    }, 200);
  };

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    if (isUserAction.current) {
      return;
    }
    setSelectedBuyers(selectedRows);
  }, [selectedRows]);

  const collectId = (
    array,
    id,
    setBuyerId,
    setPosition,
    setArrayCollection
  ) => {
    let arrayCollection = [];

    for (let index = 0; index < array.length; index++) {
      const element = array[index].user.userId;
      arrayCollection.push(element);
    }
    setArrayCollection(arrayCollection);
    setBuyerId(id);
    let position = arrayCollection.indexOf(id);
    setPosition(position);
  };

  const handlePageChange = (event, value) => {
    // setOffSet(page * 2);
    getOwnerDetails(value).then((resp) => {
      if (resp?.status == 1) {
        setPage(value);
        setProperties(resp);
        setIsModalOpen(() => resp?.userDetails?.map((i) => false));
      }
    });
  };

  const [errorMessage, setErrorMessage] = React.useState('');
  const getData = (getpage) => {
    var mounted = true;
    getOwnerDetails(getpage).then((resp) => {
      if (mounted) {
        if (resp.status === -1) {
          setErrorMessage('Owner not available');
        } else {
          setIsModalOpen(() => resp?.userDetails?.map((i) => false));
          setProperties(resp);
          // const ids = resp?.userDetails?.map((user) => user.id);
          setTotalpages(resp?.userCount);
        }
      }
    });
    return () => (mounted = false);
  };

  React.useEffect(() => {
    getData(getpage);
  }, [getpage, selectedBuyers]);

  React.useEffect(() => {
    setArrayCollection(arrayCollection);
  }, [arrayCollection]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = data.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (isChecked, index, buyerId, userCategory = [], row) => {
    const selectedIndex = selected.indexOf(index);

    let newSelected = [];
    setSelectedBuyerId(selectedBuyerId == buyerId ? '' : buyerId);

    setBuyerId(buyerId);
    setRow(row);
    setIsHiddenRightArrow(true);
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    // setOpenOwner(true);
    // setSelected(newSelected);
    let userType = '';
    if (
      userCategory[0].userType === 'Buyer' &&
      userCategory[1].userType === 'Vendor'
    ) {
      userType = 'Both';
    } else {
      userType = 'Vendor';
    }

    setSelected(newSelected);
    setUserType(userType);

    if (userType == 'Both' || userType == 'Vendor') {
      // setOpenOwner(true);
      // {
      //   showBackdrop && setOpenOwner(isChecked);
      // }
      // setOpen(true);

      if (isChecked) {
        setSelectedBuyers(
          (prevSelected) => [...prevSelected, buyerId],
          setOpenOwner(isChecked)
        );
      } else {
        setSelectedBuyers((prevSelected) =>
          prevSelected.filter((id) => id !== buyerId, setOpenOwner(false))
        );
      }
      setOpenOwner(false);
    } else {
      // setOpenOwner(true);
      setOpen(true);
      {
        showBackdrop && setOpen(isChecked);
      }
    }
  };
  const handleClickUserName = (
    isChecked,
    index,
    buyerId,
    userCategory = [],
    row
  ) => {
    const selectedIndex = selected.indexOf(index);

    let newSelected = [];
    setSelectedBuyerId(selectedBuyerId == buyerId ? '' : buyerId);

    setBuyerId(buyerId);
    setRow(row);
    setIsHiddenRightArrow(true);
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    // setOpenOwner(true);
    // setSelected(newSelected);
    let userType = '';
    if (
      userCategory[0].userType === 'Buyer' &&
      userCategory[1].userType === 'Vendor'
    ) {
      userType = 'Both';
    } else {
      userType = 'Vendor';
    }

    setSelected(newSelected);
    setUserType(userType);

    if (userType == 'Both' || userType == 'Vendor') {
      setOpenOwner(true);
      // {
      //   showBackdrop && setOpenOwner(isChecked);
      // }
      // setOpen(true);

      // if (isChecked) {
      //   setSelectedBuyers(
      //     (prevSelected) => [...prevSelected, buyerId],
      //     setOpenOwner(isChecked)
      //   );
      // } else {
      //   setSelectedBuyers((prevSelected) =>
      //     prevSelected.filter((id) => id !== buyerId, setOpenOwner(false))
      //   );
      // }
      // setOpenOwner(false);
    } else {
      // setOpenOwner(true);
      setOpen(true);
      {
        showBackdrop && setOpen(isChecked);
      }
    }
  };
  // const handleCheckClick = (event, name, buyerId, row) => {
  //   const selectedIndex = selected.indexOf(name);
  //   let newSelected = [];
  //   setBuyerId(buyerId);
  //   setRow(row);
  //   if (selectedIndex === -1) {
  //     newSelected = newSelected.concat(selected, name);
  //   } else if (selectedIndex === 0) {
  //     newSelected = newSelected.concat(selected.slice(1));
  //   } else if (selectedIndex === selected.length - 1) {
  //     newSelected = newSelected.concat(selected.slice(0, -1));
  //   } else if (selectedIndex > 0) {
  //     newSelected = newSelected.concat(
  //       selected.slice(0, selectedIndex),
  //       selected.slice(selectedIndex + 1)
  //     );
  //   }
  //   setOpenOwner(true);
  //   setSelected(newSelected);
  //   setIsChecked(!isChecked);
  // };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  // const emptyRows =
  // page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

  const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiPaginationItem-root': {
        // styles for each pagination item
        color: '#9C9C9C',
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '400px',
        margin: -3,
        padding: -3,
      },
      '& .MuiPaginationItem-root.Mui-selected': {
        // styles for the currently selected pagination item
        backgroundColor: 'white',
        color: '#6C2AD2',
      },
      '& .MuiPaginationItem-icon': {
        color: 'rgba(20, 20, 43, 1)', // Customize the arrow color here
      },
    },
  }));
  const PGcolor = useStyles();
  const history = useHistory();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const onShowChat = (binderId) => {
    setIschatopen(binderId);
    setModalIsOpen(true);
  };

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    const userTypeData = userDetail?.primaryUserType;

    if (userId) {
      getApiCall(
        GET_BINDERID + `/${agentId}` + `/${userId}` + `/0` + `/${userTypeData}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };

  const token = localStorage.getItem('moxoDetail');
  const bearerToken = JSON.parse(token);

  const toTitleCase = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* <OwnerCard
        // isChecked={isChecked}
        // setIsChecked={setIsChecked}
        selectedBuyerId={selectedBuyerId}
        setSelectedBuyerId={setSelectedBuyerId}
        showBackdrop={showBackdrop}
        setShowBackDrop={setShowBackDrop}
        open={openOwner}
        setOpen={setOpenOwner}
        buyerId={buyerId}
        setOpenBuyer={setOpen}
        row={row}
        openBuyer={open}
        userType={userType}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        // index={indexValue}
        // isHiddenRightArrow={isHiddenRightArrow}
        // setIsHiddenRightArrow={setIsHiddenRightArrow}
        buyersId={buyerId}
        position={position}
        index={indexValue}
        arrayCollection={arrayCollection}
        data={data}
        setBuyerId={setBuyerId}
        setPosition={setPosition}
        setArrayCollection={setArrayCollection}
      /> */}
      {selectedBuyers.length > 0 && showBackdrop ? (
        selectedBuyers.map((value, index, openOwner = true) => {
          return (
            <OwnerCard
              changeToggle={changeToggle}
              setChangeToggle={setChangeToggle}
              isCardSelect={isCardSelect}
              selectedBuyers={selectedBuyers}
              selectedBuyerId={selectedBuyerId}
              setSelectedBuyers={setSelectedBuyers}
              setSelectedBuyerId={setSelectedBuyerId}
              openOwner={openOwner}
              setOpenOwner={setOpenOwner}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
              arrayCollection={arrayCollection}
              setPosition={setPosition}
              setBuyerId={setBuyerId}
              setArrayCollection={setArrayCollection}
              showBackdrop={showBackdrop}
              setShowBackDrop={setShowBackDrop}
              open={openOwner}
              setOpen={setOpenOwner}
              buyerId={value}
              setOpenBuyer={setOpen}
              openBuyer={open}
              userType={userType}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              index={indexValue}
              isHiddenRightArrow={isHiddenRightArrow}
              setIsHiddenRightArrow={setIsHiddenRightArrow}
              data={data}
              position={position}
              setUserType={setUserType}
              count={index}
              rowData={row}
              onShowChat={onShowChat}
            />
          );
        })
      ) : (
        <OwnerCard
          // selectedBuyers={value}
          selectedBuyerId={selectedBuyerId}
          setSelectedBuyerId={setSelectedBuyerId}
          openOwner={openOwner}
          setOpenOwner={setOpenOwner}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          arrayCollection={arrayCollection}
          setPosition={setPosition}
          setBuyerId={setBuyerId}
          setArrayCollection={setArrayCollection}
          showBackdrop={showBackdrop}
          setShowBackDrop={setShowBackDrop}
          open={openOwner}
          setOpen={setOpenOwner}
          buyerId={buyerId}
          setOpenBuyer={setOpen}
          openBuyer={open}
          userType={userType}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          index={indexValue}
          isHiddenRightArrow={isHiddenRightArrow}
          setIsHiddenRightArrow={setIsHiddenRightArrow}
          data={data}
          position={position}
          rowData={row}
          setUserType={setUserType}
          onShowChat={onShowChat}
        />
      )}
      {data?.length > 0 && (
        <Paper sx={{ width: '100%', mb: 2 }}>
          {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
          <TableContainer style={{ border: '1px solid #D9D9D9' }}>
            <Table
              // sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size="medium"
            >
              <EnhancedTableHead
                headCells={headCells}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                // rowCount={tableData.length}
              />
              <TableBody>
                {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.sort(getComparator(order, orderBy)).slice() */}
                {/* {stableSort(tableData, getComparator(order, orderBy)) */}
                {/* .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) */}
                {Array.isArray(data) ? (
                  data?.map((row, index) => {
                    const isItemSelected = isSelected(index);

                    const labelId = `enhanced-table-checkbox-${index}`;
                    const buyerId = row?.user?.userId;
                    const isCardSelected = selectedBuyers.includes(buyerId);
                    const userCategory = row?.userCategory;
                    // const buyerId = data?.map((row) => row?.user?.userId) || [];
                    return (
                      <TableRow
                        // hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        // key={row.name}
                        // selected={isItemSelected}
                      >
                        {/* <TableCell padding="checkbox">
                          {' '}
                          {!matchessm && (
                            <Typography
                              style={{
                                paddingLeft: '20.88px',
                                marginRight: '-10px',
                              }}
                            >
                              <input
                                checked={selectedBuyers.includes(buyerId)}
                                onChange={(event) => {
                                  event.stopPropagation();

                                  handleSelection(
                                    buyerId,
                                    event.target.checked
                                  );

                                  collectId(
                                    data,
                                    buyerId,
                                    setBuyerId,
                                    setPosition,
                                    setArrayCollection
                                  );
                                }}
                                type="checkbox"
                              />
                            </Typography>
                          )}
                          <Typography sx={checkbox_style} />
                        </TableCell> */}
                        <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                        >
                          <Typography
                            sx={[userDetCont, { marginLeft: '10px' }]}
                          >
                            <Typography sx={imageCont}>
                              {row?.user?.userProfile == '' ||
                              row?.user?.userProfile == null ? (
                                <Avatar
                                  style={{
                                    width: '29px',
                                    height: '29px',
                                    backgroundColor: '#666666',
                                    fontFamily: 'poppins',
                                    fontSize: '14px',
                                  }}
                                  onClick={(event) => {
                                    handleClick(
                                      event.target.checked,
                                      index,
                                      buyerId,
                                      userCategory,
                                      row
                                    );

                                    collectId(
                                      data,
                                      buyerId,
                                      setBuyerId,
                                      setPosition,
                                      setArrayCollection
                                    );
                                  }}
                                  sx={{
                                    fontFamily: 'poppins',
                                    fontSize: '12px',
                                  }}
                                >
                                  {row?.user?.userName
                                    ?.charAt(0)
                                    ?.toUpperCase() +
                                    row?.user?.userSurName
                                      ?.charAt(0)
                                      ?.toUpperCase()}
                                </Avatar>
                              ) : (
                                <Avatar
                                  alt="Remy"
                                  src={row?.user?.userProfile}
                                  style={{ width: '29px', height: '29px' }}
                                  onClick={(event) => {
                                    handleClick(
                                      event.target.checked,
                                      index,
                                      buyerId,
                                      userCategory,
                                      row
                                    );

                                    collectId(
                                      data,
                                      buyerId,
                                      setBuyerId,
                                      setPosition,
                                      setArrayCollection
                                    );
                                  }}
                                />
                              )}
                              &nbsp;&nbsp;
                              <Typography sx={displayFlex}>
                                <Typography
                                  sx={{
                                    fontSize: '12px',
                                    fontFamily: 'Poppins',
                                    fontWeight: '400',
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap',
                                    color: '#112347',
                                  }}
                                  // onClick={(event) =>
                                  //   handleClick(
                                  //     event.target.checked,
                                  //     index,
                                  //     buyerId,
                                  //     // userCategory,
                                  //     row
                                  //   )
                                  // }
                                  onClick={(event) => {
                                    handleClickUserName(
                                      event.target.checked,
                                      index,
                                      buyerId,
                                      userCategory,
                                      row,
                                      setShowBackDrop(false)
                                    );

                                    collectId(
                                      data,
                                      buyerId,
                                      setBuyerId,
                                      setPosition,
                                      setArrayCollection
                                    );
                                  }}
                                >
                                  {toTitleCase(row?.user?.userName)}{' '}
                                  {toTitleCase(row?.user?.userSurName)}
                                </Typography>
                              </Typography>
                            </Typography>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          {<CategoryContainer data={row} />}
                        </TableCell>
                        <TableCell align="left">
                          <Box sx={{ display: 'flex', justifyContent: 'left' }}>
                            {
                              <Contact
                                row={row}
                                directcomm={directcomm}
                                index={null}
                              />
                            }
                          </Box>
                        </TableCell>

                        <TableCell align="left">
                          {' '}
                          {
                            <TagContainer
                              anchorEl={anchorEl}
                              setAnchorEl={setAnchorEl}
                              idPop={idPop}
                              handleIconClick={handleIconClick}
                              row={row}
                              tagArray={tagArray}
                            />
                          }
                        </TableCell>

                        <TableCell align="left">
                          {
                            <ActionContainer
                              rowData={row}
                              setFeedBackData={setFeedBackData}
                              feedBackData={feedBackData}
                              marginLeft={true}
                              openFeedback={openFeedback}
                              setOpenFeedback={setOpenFeedback}
                              userName={userName}
                              setUserType={setUserType}
                              setUserName={setUserName}
                              setBuyerId={setBuyerId}
                              setUserEmail={setUserEmail}
                              setUserInitial={setUserInitial}
                            />
                          }
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  //   }
                  // {emptyRows > 0 && (
                  <TableRow
                  // style={{
                  //   height: 53 * emptyRows,
                  // }}
                  >
                    <TableCell colSpan={4} />
                    {errorMessage && (
                      <div>
                        <Typography
                          sx={{
                            fontFamily: 'Poppins',
                            fontSize: '10px',
                            color: '#666666',
                            paddingLeft: '100px',
                          }}
                        >
                          {errorMessage}
                        </Typography>
                      </div>
                    )}
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}

      {/* <ContactPagination 
      userCount={data?.userCount}
      
       /> */}

      {!expandFeedback && (
        <BuyersCard
          setSelectedBuyerId={setSelectedBuyerId}
          selectedBuyerId={selectedBuyerId}
          setSelectedBuyers={setSelectedBuyers}
          showBackdrop={showBackdrop}
          setShowBackDrop={setShowBackDrop}
          buyersId={buyerId}
          openOwner={openOwner}
          setOpenOwner={setOpenOwner}
          open={open}
          userType={userType}
          setOpen={setOpen}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          // index={indexValue}
          expandFeedback={expandFeedback}
          setExpandFeedback={setExpandFeedback}
          isHiddenRightArrow={isHiddenRightArrow}
          setIsHiddenRightArrow={setIsHiddenRightArrow}
          data={data}
          position={position}
          arrayCollection={arrayCollection}
          setPosition={setPosition}
          setBuyerId={setBuyerId}
          setArrayCollection={setArrayCollection}
          setUserType={setUserType}
          rowData={row}
        />
      )}
      {(openFeedback || expandFeedback) && (
        <Feedback
          buyerId={buyerId}
          expandFeedback={expandFeedback}
          setExpandFeedback={setExpandFeedback}
          openFeedback={openFeedback}
          setOpenFeedback={setOpenFeedback}
          setUserName={setUserName}
          userName={userName}
          data={feedBackData}
          userType={userType}
          ownercardprop={userType == 'Vendor' ? true : false}
          marketShow={false}
          proid={0}
          userEmail={userEmail}
          address={address}
          setAddress={setAddress}
          directcomm={directcomm}
          index={null}
          row={feedBackData}
          buyerCardOpen={userType === 'Buyer' ? open : openOwner}
          setBuyerCardOpen={userType === 'Buyer' ? setOpen : setOpenOwner}
          userInitial={userInitial}
        />
      )}
      {totalPages > 10 && (
        <Stack sx={{ float: 'right' }} style={{ color: '#6C2AD2' }}>
          <Pagination
            className={PGcolor.root}
            sx={{ p: '20px 0' }}
            count={Math.ceil(totalPages / 10)}
            // defaultPage={getpage}
            page={page}
            onChange={handlePageChange}
          />
        </Stack>
      )}
      <Popover
        sx={{
          boxShadow: 'none',
          padding: 0,
          maxWidth: '600px',
        }}
        open={openPop}
        anchorEl={anchorEl}
        onClose={handleIconClick}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <TagPopOver
          postTagId={postTagId}
          setLoaderUser={setLoaderUser}
          LoaderTag={LoaderTag}
          setLoaderTag={setLoaderTag}
          userTagDetails={userTagDetails}
          setUserTagDetails={setUserTagDetails}
          tagArray={tagArray}
          setTagArray={setTagArray}
          Apifunctions={Apifunctions}
          LoaderUser={LoaderUser}
          userName={userName}
        />
      </Popover>
      {modalIsOpen && <Moxochat open={modalIsOpen} onClose={setModalIsOpen} />}
    </Box>
  );
}
